export const hourFormOptions = Array.from({ length: 24 }, (_, index) => {
  const value = index.toString().padStart(2, "0");
  return {
    label: value,
    value,
  };
});

export const minuteFormOptions = Array.from({ length: 60 }, (_, index) => {
  const value = index.toString().padStart(2, "0");
  return {
    label: value,
    value,
  };
});